import { DatePipe, CommonModule, NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { ActivatedRoute, Router } from '@angular/router';
import { OAService } from '../../../services/oa.service';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { SelectButtonModule } from 'primeng/selectbutton';
import { DropdownModule } from 'primeng/dropdown';
import { NotificationService } from '../../../services/notification.service';

@Component({
    selector: 'app-oa-compilance-details',
    imports: [FormsModule, CommonModule, ToastModule, DialogModule, ButtonModule, InputTextModule, CalendarModule, TableModule, SelectButtonModule, DropdownModule, NgIf],
    templateUrl: './oa-compilance-details.component.html',
    styleUrl: './oa-compilance-details.component.scss'
})
export class OaCompilanceDetailsComponent {
  errors: boolean = false;
  isLoading: boolean = true;
  popupOpen: boolean = false;
  isOARecordExist: boolean = false;
  tagNumber: string = '';
  dialogTitle: string = '';
  oaCompilanceDetails: any = [];
  services: any = {};
  TlrDropdownData = ["", "Monthly", "Quaterly", "Bi-Annually", "Annual", "NA"];
  mocWorkOrderNumber: string = '';

  // Flag to determine if the OA User ID Owner field should be editable
  oaUserIdEditable: boolean = false;

  private route = inject(ActivatedRoute);
  private router = inject(Router);
  mocWorkOrderList: any = [
  ];
  constructor(private oaService: OAService, private messageService: NotificationService) {
    this.route.params.subscribe(params => {
      const tagNumber = params['tagNumber'];
      this.tagNumber = tagNumber;
      this.oaCompilanceDetails.tagNumber = tagNumber; // Set the tag number in the form model
    });

    // Check which route was used to navigate here
  }

  // Check which route was used to navigate to this component
  checkRouteSource() {
    // Get the current URL
    const currentUrl = this.router.url;

    // If we're coming from data-editor/oa-details, make the OA User ID Owner field editable
    if (currentUrl.includes('data-editor/oa-details') || this.oaCompilanceDetails.isOARecordExist === false) {
      this.oaUserIdEditable = true;
      if (!this.oaCompilanceDetails.isOARecordExist) {
        this.oaCompilanceDetails.oaEmail = sessionStorage.getItem('currentUser') || '';
      } else {
        this.oaCompilanceDetails.oaEmail = this.oaCompilanceDetails.submitCAI || '';
      }
    } else {
      this.oaUserIdEditable = false;
      this.oaCompilanceDetails.oaEmail = this.oaCompilanceDetails.submitCAI || '';
    }
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params['tagNumber']) {
        this.tagNumber = params['tagNumber'];
      }
    });
    if (!this.tagNumber) {
      this.isLoading = false;
      return;
    }
    this.getOACompilanceDetails();
  }

  getOACompilanceDetails() {
    this.oaService.getTagDetails(this.tagNumber).subscribe({
      next: (data: any) => {
        if (data) {
          this.oaCompilanceDetails = data;
          this.isOARecordExist = this.oaCompilanceDetails.isOARecordExist || false; // Check if the OA record exists
          this.oaCompilanceDetails.maxOrders.push('');
          if (this.oaCompilanceDetails.namoDate) { this.oaCompilanceDetails.namoDate = new Date(this.oaCompilanceDetails.namoDate); }
          if (this.oaCompilanceDetails.permanentRepairDate) { this.oaCompilanceDetails.permanentRepairDate = new Date(this.oaCompilanceDetails.permanentRepairDate); }
          if (this.oaCompilanceDetails.closureDate) {
            this.oaCompilanceDetails.closureDate = new Date(this.oaCompilanceDetails.closureDate);
          }
          // if (!this.oaCompilanceDetails.isOARecordExist) {
          //   this.oaCompilanceDetails.oaEmail = sessionStorage.getItem('currentUser') || '';
          //   this.oaUserIdEditable = true; // Make the OA User ID Owner field editable if the record does not exist
          // } else {
          //   this.oaCompilanceDetails.oaEmail = this.oaCompilanceDetails.submitCAI || '';
          //   this.oaUserIdEditable = false; // Make the OA User ID Owner field read-only if the record exists
          // }
          this.checkRouteSource();

          // Set the flag to indicate that the OA record exists
        }
      },
      error: (error: any) => {
        console.error('Error fetching OA data:', error);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  searchMocWorkOrder() {
    this.oaService.getWorkOrderList(this.mocWorkOrderNumber.toString()).subscribe({
      next: (data: any) => {
        if (data) {
          this.mocWorkOrderList = data;
        }
      },
      error: (error: any) => {
        console.error('Error fetching OA data:', error);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  openMocOrderPopujp() {
    this.popupOpen = true;

  }

  setWorkOrder(row: any) {
    this.oaCompilanceDetails.mocWorkOrderNumber = row.WorkOrderNo;
    this.popupOpen = false;
    this.mocWorkOrderList = [];
  }

  setSavePayload() {
    let payload: any = {
      tagNumber: this.oaCompilanceDetails.tagNumber || "",
      facilityId: this.oaCompilanceDetails.facility || "",
      oaEmail: this.oaCompilanceDetails.oaEmail || "",
      surveillance: this.oaCompilanceDetails.surveillance || "",
      wonum: this.oaCompilanceDetails.woNum || "",
      comments: this.oaCompilanceDetails.comments || "",
      tlrClosureEmail: this.oaCompilanceDetails.closureUserID || "",
      tlrClosureTimeStamp: null,
      permanentRepairDate: null,
      namoDate: null,
      mocwoNum: this.oaCompilanceDetails.mocWorkOrderNumber || "",
      completedStatus: false,
    };
    if (this.oaCompilanceDetails?.closureDate) {
      payload.tlrClosureTimeStamp = this.convertToMMDDYYYY(this.oaCompilanceDetails?.closureDate) || null;
    }
    if (this.oaCompilanceDetails?.permanentRepairDate) {
      payload.permanentRepairDate = this.convertToMMDDYYYY(this.oaCompilanceDetails?.permanentRepairDate) || null;
    }
    if (this.oaCompilanceDetails?.namoDate) {
      payload.namoDate = this.convertToMMDDYYYY(this.oaCompilanceDetails?.namoDate) || null;
    }

    return payload;
  }
  convertToMMDDYYYY(date: Date | null): string {
    if (!date) return '';
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }

  isInvalidDate: boolean = false;
  validateDate(dateString: string | null): boolean {
    if (!dateString) return true; // Allow empty value

    // Regular expression for MM/DD/YYYY, MM/DD/YY, MM-DD-YYYY, or MM-DD-YY
    const dateRegex = /^(0[1-9]|1[0-2])[\/\-](0[1-9]|[12]\d|3[01])[\/\-](19|20)?\d{2}$/;

    if (!dateRegex.test(dateString)) {
      this.isInvalidDate = true;
      return false;
    }

    // Convert to Date object to validate actual date
    const parts = dateString.split(/[\/\-]/);  // Split on either / or -
    const year = parts[2].length === 2 ? '20' + parts[2] : parts[2];
    const month = parseInt(parts[0], 10) - 1;
    const day = parseInt(parts[1], 10);
    const date = new Date(parseInt(year), month, day);

    const isValid = date.getMonth() === month &&
      date.getDate() === day &&
      date.getFullYear() === parseInt(year);

    this.isInvalidDate = !isValid;
    return isValid;
  }
  checkErrors() {
    let NoErrors = true;
    if (this.oaCompilanceDetails?.namoDate < this.oaCompilanceDetails?.permanentRepairDate) {
      NoErrors = false;
    }

    return NoErrors;
  }

  saveDetails() {
    this.errors = false;
    this.isLoading = true;
    let NoErrors = this.checkErrors();

    if (NoErrors) {
      let payload = this.setSavePayload();
      if (this.oaCompilanceDetails.isOARecordExist) {
        this.oaService.updateOA(payload).subscribe({
          next: (data: any) => {
            if (data) {
              this.messageService.showSuccess('Data saved successfully');
              // this.router.navigate(['/oa']);
              this.getOACompilanceDetails();
            }
          },
          error: (error: any) => {
            this.messageService.showError('Failed to save data');
          },
          complete: () => {
            this.isLoading = false;
          }
        });
      }
      else {
        this.oaService.saveOA(payload).subscribe({
          next: (data: any) => {
            if (data) {
              this.messageService.showSuccess('Data saved successfully');
              // this.router.navigate(['/oa']);
              this.getOACompilanceDetails();

            }
          },
          error: (error: any) => {
            this.messageService.showError('Failed to save data');
          },
          complete: () => {
            this.isLoading = false;
          }
        });
      }
    } else {
      this.errors = true;
      this.messageService.showError('NAMO Date should be less than Permanent Repair Date');
      this.isLoading = false;
    }
  }

  convertToISO(dateString: string): string {
    if (!dateString) return '';
    const [day, month, year] = dateString.split('-');
    const monthIndex = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].indexOf(month);
    if (monthIndex === -1) return '';
    const formattedDate = new Date(parseInt(`20${year}`), monthIndex, parseInt(day));
    return formattedDate.toISOString();
  }
}
